export default "__VITE_ASSET__MxHuc2Uk__"